import React, { memo } from "react";
import PropTypes from "prop-types";
import BaseSpinner from "../BaseSpinner";
import models from "../../types/models";
import { Link } from "react-router-dom";
import "./style.scss";

function BaseButton({
  to,
  children,
  className,
  name,
  onClick,
  disabled,
  id,
  loading,
  type,
  negative,
  typeSpinner,
  target,
  native,
  href,
  unfilled,
  unfilledGray,
  unfilledWhite,
  unfilledGradient,
  gradientWrapperCls,
}) {
  BaseButton.propTypes = {
    className: PropTypes.string,
    gradientWrapperCls: PropTypes.string,
    to: PropTypes.string,
    children: PropTypes.node,
    name: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    native: PropTypes.bool,
    unfilled: PropTypes.bool,
    unfilledGray: PropTypes.bool,
    unfilledWhite: PropTypes.bool,
    unfilledGradient: PropTypes.bool,
    type: PropTypes.string,
    negative: PropTypes.bool,
    id: PropTypes.string,
    target: PropTypes.string,
    href: PropTypes.string,
    typeSpinner: models.typeSpinner,
  };
  const cls = ["button-wrapper__button"];
  const gradientWrapperClses = [];
  cls.push(className);
  if (gradientWrapperCls) {
    gradientWrapperClses.push(gradientWrapperCls);
  }
  if (to) cls.push("link-style");
  if (type !== "text") cls.push("min-width");
  if (negative) cls.push("button-wrapper__button_negative");
  if (type !== "text") cls.push("btn-height");
  if (unfilled) cls.push("button-wrapper__button-unfilled");
  if (unfilledGray) cls.push("button-wrapper__button-unfilledGray");
  if (unfilledWhite) cls.push("button-wrapper__button-unfilledWhite");
  if (unfilledGradient) cls.push("button-wrapper__button-unfilledGradient");
  const propsData = {
    name,
    className: cls.join(" "),
  };

  if (native) {
    return (
      <a target={target} href={href} {...propsData}>
        {children}
      </a>
    );
  }
  if (to) {
    return (
      <Link to={to} target={target} {...propsData}>
        {children}
      </Link>
    );
  }

  const onClickHandler = (event) => {
    if (onClick && !disabled) {
      onClick(event);
    }
  };

  if (unfilledGradient) {
    return (
      <div
        className={[
          "button-wrapper__gradient-wrapper",
          ...gradientWrapperClses,
        ].join(" ")}
      >
        <button
          id={id}
          disabled={disabled}
          className={cls.join(" ")}
          type={type || "button"}
          onClick={onClickHandler}
        >
          {loading ? <BaseSpinner type={typeSpinner} /> : children}
        </button>
      </div>
    );
  }

  return (
    <button
      id={id}
      disabled={disabled}
      className={cls.join(" ")}
      type={type || "button"}
      onClick={onClickHandler}
    >
      {loading ? <BaseSpinner type={typeSpinner} /> : children}
    </button>
  );
}

export default memo(BaseButton);
